import { render, staticRenderFns } from "./editBtn.vue?vue&type=template&id=8076f20e&scoped=true"
import script from "./editBtn.vue?vue&type=script&lang=js"
export * from "./editBtn.vue?vue&type=script&lang=js"
import style0 from "./editBtn.vue?vue&type=style&index=0&id=8076f20e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8076f20e",
  null
  
)

export default component.exports